import { createElement } from 'react'
import { FlagCell } from 'routes/shared/components'
import { createInWinImage } from 'shared/components/table/cellRenderers'
import { Table } from 'shared/components'
import { Favorite } from './components/favoriteButton'
import NameRedirect from './components/tournamentName'

export const createColumns = () => [
  {
    Header: 'Logo',
    accessor: 'tournamentDTO.logo',
    Cell: createInWinImage,
    maxWidth: 72,
    width: 72,
  },
  {
    Header: 'Name',
    accessor: 'tournamentDTO.tournamentName',
    maxWidth: 300,
    width: 300,
    Cell: (props) => createElement(NameRedirect, { ...props }),
  },
  {
    Header: 'Sport',
    accessor: 'tournamentDTO.sportType',
  },
  {
    Header: 'Jurisdiction',
    accessor: 'tournamentDTO.jurisdiction.logo',
    Cell: FlagCell,
  },
  {
    Header: 'Start time',
    accessor: 'tournamentDTO.startTime',
    Cell: Table.CellRenderers.DateTimeCell,
    maxWidth: 200,
    width: 200,
  },
  {
    Header: 'Favorite',
    id: 'controls',
    width: 180,
    minWidth: 180,
    accessor: (value) => value,
    Cell: (props) => createElement(Favorite, { ...props }),
  },
]
